var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-widget-template-slider" }, [
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.canScrollLeft,
            expression: "canScrollLeft",
          },
        ],
        staticClass:
          "chat-widget-template-slider__arrow chat-widget-template-slider__arrow--left",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.scrollBy(-1)
          },
        },
      },
      [_c("i", { staticClass: "bi bi-chevron-left" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "track",
        staticClass: "chat-widget-template-slider__track",
        on: { scroll: _vm.updateArrows },
      },
      _vm._l(_vm.templates, function (tpl) {
        return _c(
          "button",
          {
            key: tpl.id,
            staticClass: "chat-widget-template-slider__card",
            attrs: { disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.$emit("action", "open_showcase:" + tpl.id)
              },
            },
          },
          [
            _c("div", { staticClass: "chat-widget-template-slider__thumb" }, [
              _c("img", {
                staticClass: "chat-widget-template-slider__img",
                attrs: { src: tpl.thumbnail, alt: tpl.name },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chat-widget-template-slider__info" }, [
              _c("div", { staticClass: "chat-widget-template-slider__name" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.getStyleLabel(tpl) || tpl.name) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "chat-widget-template-slider__meta" }, [
                _vm._v("\n          " + _vm._s(_vm.getTypeLabel(tpl))),
                _vm.getTypeLabel(tpl) ? _c("span", [_vm._v(" · ")]) : _vm._e(),
                _vm._v(
                  _vm._s(tpl.width) + "×" + _vm._s(tpl.height) + "\n        "
                ),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.canScrollRight,
            expression: "canScrollRight",
          },
        ],
        staticClass:
          "chat-widget-template-slider__arrow chat-widget-template-slider__arrow--right",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.scrollBy(1)
          },
        },
      },
      [_c("i", { staticClass: "bi bi-chevron-right" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }